export function waitForGoogleMaps(callback) {
  if (window.google && window.google.maps) {
    callback();
  } else {
    setTimeout(() => waitForGoogleMaps(callback), 50);
  }
}
